module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres6bu"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "unLoadBool": false,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "receivedStore": _vm.receivedHres6buIndex,
      "searchBoxAlias": "approve",
      "maxRowspan": _vm.maxRowspan.index,
      "detailEvent": _vm.detailEvent,
      "approveEvent": _vm.postHres6buSendApprove
    },
    model: {
      value: (_vm.searchParams),
      callback: function($$v) {
        _vm.searchParams = $$v
      },
      expression: "searchParams"
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "labels": _vm.labels[_vm.dash.nowLang],
      "detail": _vm.detail,
      "tab2Table": _vm.columns[_vm.dash.nowLang].detailTab2,
      "toggle": _vm.toggle,
      "nowLang": _vm.dash.nowLang
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a8f5198!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6bu/component.vue
// module id = 3533
// module chunks = 1